import React, { useState } from 'react';
import { Phone, Mail, Instagram, MapPin } from 'lucide-react';
import { siteInfo } from '../data/mock';
import PrivacyModal from './PrivacyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} />
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section con logo más grande */}
          <div className="lg:col-span-2">
            <div className="mb-6 bg-white/10 p-6 rounded-2xl inline-block">
              <img 
                src="https://customer-assets.emergentagent.com/job_responsive-design-68/artifacts/pi8nnphe_LUCARS_LOGO.png" 
                alt="LUCARS - Siempre en Movimiento" 
                className="h-24 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              Brindamos soluciones de movilidad con vehículos eléctricos y de gasolina en la Península de Yucatán. 
              Ayudamos a generar ingresos mientras cuidamos el medio ambiente.
            </p>
            <div className="flex space-x-4">
              <a
                href={siteInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#63E61E] hover:text-gray-900 transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-[#63E61E] transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-[#63E61E] transition-colors"
                >
                  Quiénes Somos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how')}
                  className="text-gray-400 hover:text-[#63E61E] transition-colors"
                >
                  Cómo lo Hacemos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why')}
                  className="text-gray-400 hover:text-[#63E61E] transition-colors"
                >
                  Por Qué Elegirnos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-[#63E61E] transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3 text-gray-400">
                <Phone className="w-5 h-5 text-[#63E61E] flex-shrink-0" />
                <a href={`tel:${siteInfo.phone}`} className="hover:text-[#63E61E] transition-colors">
                  {siteInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Mail className="w-5 h-5 text-[#63E61E] flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="hover:text-[#63E61E] transition-colors">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <Instagram className="w-5 h-5 text-[#63E61E] flex-shrink-0" />
                <a
                  href={siteInfo.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#63E61E] transition-colors"
                >
                  @{siteInfo.instagram}
                </a>
              </li>
              <li className="flex items-center space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 text-[#63E61E] flex-shrink-0" />
                <span>Mérida, Yucatán</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {siteInfo.name}. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <button
                onClick={() => setIsPrivacyModalOpen(true)}
                className="text-gray-400 hover:text-[#63E61E] text-sm transition-colors underline"
              >
                Aviso de Privacidad
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;